import type { CarbonIconType } from '@carbon/icons-react';
import { PinFilled } from '@carbon/icons-react';
import type { ColorTokens } from '@repo/theme';
import { useTheme } from '@repo/theme';
import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

import { BaseTag } from './base-tag';

type VisibilityTagType = 'admin' | 'pinned' | 'private' | 'private_history' | 'public';

type TagConfig = {
    icon: CarbonIconType | string;
    label: TLabel;
    color?: string;
    iconFill?: string;
};

function getTagConfig(colors: ColorTokens): Record<VisibilityTagType, TagConfig> {
    return {
        admin: {
            icon: '🔒',
            label: t('visibility.only_visible_to_admins', 'Only visible to Admins'),
            color: colors.colorTextHint,
        },
        pinned: {
            icon: PinFilled,
            label: t('action.pinned', 'Pinned'),
            color: colors.colorTextPrimary,
            iconFill: colors.colorTextPrimary,
        },
        private: {
            icon: '🔒',
            label: t('comment_feedback.only_visible_to_you', 'Only visible to you'),
            color: colors.colorTextHint,
        },
        private_history: {
            icon: '🔒',
            label: t('profile_answers.history_private', "This user's history is private."),
            color: colors.colorTextHint,
        },
        public: {
            icon: '👁️',
            label: t('profile_answers.visible_to_everyone', 'Visible to everyone'),
            color: colors.colorTextHint,
        },
    };
}

type VisibilityTagProps = {
    type: VisibilityTagType;
};

export function VisibilityTag({ type }: VisibilityTagProps) {
    const { colors } = useTheme();
    const config = getTagConfig(colors)[type];
    return (
        <BaseTag
            backgroundColor='transparent'
            color={config.color}
            iconFill={config.iconFill}
            label={config.label}
            prefix={config.icon}
            type='small'
        />
    );
}
